import { FormDateInputComponent } from 'src/features/generalForms/builder/types/DateInput';
import { DateFormats, localFormat, toDateOrNull } from 'src/helpers/date-helpers';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const FormDateInput: FormDateInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <></>;
  }

  return (
    <AnswerPreviewRow<Date>
      value={toDateOrNull(value) || undefined}
      renderValue={(val) => localFormat(val, DateFormats.longDate)}
      {...props}
    />
  );
};
